module.exports = __webpack_public_path__ + "img/icon-step-1-summary-payment.09aa0853.svg";